export const objectIsEmpty = (obj) => Object.keys(obj).length === 0;
